package com.essntl.features.itinerary.ui.edit_itinerary_service.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.features.itinerary.ui.edit_itinerary_service.EditItineraryServiceState
import com.essntl.uikit.rememberFind
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import core.dateformat.ui.formatDate
import kotlinx.datetime.LocalDate

@Composable
fun LastUpdatedLabel(
    state: EditItineraryServiceState,
) {
    val itineraryService = state.itineraryService.value

    val profile = rememberFind(
        listOf(state.getProfile.data),
        itineraryService.updatedBy,
    ) { it?.id }

    itineraryService.updatedAt?.let { updatedAt ->
        Row(
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.fillMaxWidth(),
        ) {
            Row(
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Text(
                    text = "Last modified ",
                    style = MaterialTheme.esTypography.c1Medium13,
                    color = MaterialTheme.esColorScheme.textDisabled,
                )
                Text(
                    text = LocalDate.parse(updatedAt.substring(0, 10)).toString().formatDate("."),
                    style = MaterialTheme.esTypography.c1Medium13,
                    color = MaterialTheme.esColorScheme.textTertiary,
                )

                profile?.let { p ->
                    Text(
                        text = " By ",
                        style = MaterialTheme.esTypography.c1Medium13,
                        color = MaterialTheme.esColorScheme.textDisabled,
                    )
                    Text(
                        text = p.prettyName,
                        style = MaterialTheme.esTypography.c1Medium13,
                        color = MaterialTheme.esColorScheme.textTertiary,
                    )
                }
            }
        }
    }
}
